<div class="back-container">

  <button
    pButton
    pRipple
    *ngIf="backButton"
    #button
    type="button"
    class="btn-primary btn-back"
    title="Regresar"
    pTooltip="Regresar"
    tooltipPosition="right"
  >
    <div class="first-back-section">
      <fa-icon [icon]="['fas', 'angle-left']"></fa-icon>
    </div>
  </button>

  <button
    pButton
    pRipple
    class="btn-primary home-button"
    pTooltip="Inicio"
    tooltipPosition="right"
    title="Inicio"
    routerLink="/home"
  >
    <fa-icon [icon]="['fas', 'home']"></fa-icon>
  </button>

</div>